import styled from 'styled-components';

export const DiagnosticPhotosGallerySlide = styled.img`
  width: 100%;
`;
